export default "__VITE_ASSET__DFLvkA37__"